import React, { useContext } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import TopNav from 'components/TopNav';
import styles from './styles.module.scss';
// import { CircularProgress } from '@material-ui/core';
import { useQueryClient } from 'react-query';
// import { AUTH_TOKEN, SEARCH_JOB_TRIAL_FILTER } from '../../config/constants';
import { textFooterEnv } from '../../utils/utils';
import * as searchApi from 'api/search';
import ListJob from '../../components/Jobs/ListJob';
import isEmpty from 'lodash/isEmpty';
import Typography from '@material-ui/core/Typography';
// import error from '../../common/error';
import { useSelector } from 'react-redux';
// import Cookies from 'js-cookie';
import { getAllItemJobResource } from 'api/itemJobResources';
import { AppContext } from '../../context/AppContext';
// import { getJobDetail } from '../../api/job';
import qs from 'query-string';
import { getAllResource } from 'api/agentResources';
import { PROFILE } from '../../config/constants';
import pick from 'lodash/pick';


function SearchJobTrialResult(props) {
  const appContext = useContext(AppContext);
  const history = useHistory();
  const location = useLocation();
  const queryClient = useQueryClient();
  const envInfoList = useSelector((state) => state.envInfo.data);
  const rawJobEntryTrialSearchList = queryClient.getQueryData('jobSearchJobTrialList');
  // const rawMessage = queryClient.getQueryData('jobSearchJobTrialListMessage');
  // const rawMessageErr = queryClient.getQueryData('jobSearchJobListMessageErr');
  // const { data: itemJobResources } = useQuery(['itemJobResource'], () => getAllItemJobResource(), { cacheTime: Infinity });

  // const [jobEntrySearchList, setJobEntryTrialSearchList] = useState();
  const itemJobResources = props.jobResources || []
  const jobEntrySearchList = props.dJobs || []
  const message = props.message || []
  // const [message, setMessage] = useState([]);
  const isAuthenticated = appContext.isAuthenticated


  // useEffect(() => {
  //   if (!(rawJobEntryTrialSearchList?.length > 0)) {
  //     const fetch = async () => {
  //       const dataRaw = await getLocalStorage(SEARCH_JOB_TRIAL_FILTER);
  //       let data = {};
  //       if (dataRaw) {
  //         try {
  //           data = JSON.parse(dataRaw);
  //         } catch (e) {
  //           console.error(e);
  //         }
  //       }
  //       const { data: userSearchList, messageErr } = await searchApi.searchJob(data);
  //       setJobEntryTrialSearchList(userSearchList);
  //       if (!(userSearchList.length > 0)) {
  //         setMessage(messageErr);
  //       }
  //     };
  //     fetch();
  //   } else {
  //     setJobEntryTrialSearchList(rawJobEntryTrialSearchList);
  //     if (!(rawJobEntryTrialSearchList.length > 0)) {
  //       setMessage(rawMessageErr);
  //     }
  //   }
  // }, [rawJobEntryTrialSearchList, rawMessage]);

  const textFooter = () => {
    return textFooterEnv(envInfoList ?? []);
  };

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div className={styles.searchScreen}>
        <TopNav name={'仕事検索（ビジター）'} hasBackIcon={true} dir={`${process.env.RAZZLE_PUBLIC_URL}/job-lp`} hasHamburger={isAuthenticated} />

        <div style={{ marginTop: 65, marginBottom: 60 }} className={'search-job-trial-result-wrapper'}>
          {isEmpty(jobEntrySearchList) ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
              <center>
                <Typography variant="h6" className="font-2">
                  {message}
                </Typography>
              </center>
            </div>
          ) : (
            <ListJob jobList={jobEntrySearchList}
                     history={history}
                     act={!isAuthenticated ? 'trial' : ''}
                     itemJobResources={itemJobResources ?? []}
                     agentResource={props?.agentResource ?? {}}
                     type="search-job-trial-result"
            />
          )}
        </div>

        <div className="d-btn-back-search">
          <Link className="btn btn-main"
                variant="contained"
                style={{
                  borderRadius: 30,
                  padding: '5px 20px',
                  height: 'unset',
                  width: 'unset',
                  textDecoration: 'unset',
                }}
                to={`${process.env.RAZZLE_PUBLIC_URL}/job-lp`}>
            検索条件を変えて再検索
          </Link>
        </div>

        <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
          <p style={{ color: 'var(--text3)' }} className="font-3"
             dangerouslySetInnerHTML={{ __html: textFooter() }}></p>
        </div>
      </div>
    </div>
  );
}

SearchJobTrialResult.getInitialProps = async ({
                                                req, res, match, history, location, ...ctx
                                              }) => {

  const data = typeof window !== 'undefined' ? qs.parse(location?.search) : req?.query;
  const params = data || {};

  if (params?.title === 'null' || params?.title === 'undefined') {
    delete params.title;
  }

  if (params?.minimumSalary === 'null' || params?.minimumSalary === 'undefined') {
    delete params.minimumSalary;
  }

  if (params?.minimumSalary) {
    params.minimumSalary = +params.minimumSalary;
  }

  let jobTags = [];
  if (params?.jobTags) {
    try {
      jobTags = JSON.parse(params?.jobTags);
    } catch (e) {
      jobTags = [];
    }
  }
  delete params.jobTags;
  if (jobTags.length) {
    params.jobTags = jobTags;
  }

  let items = [];
  if (params?.items) {
    try {
      items = JSON.parse(params?.items);
    } catch (e) {
      items = [];
    }
  }
  delete params.items;
  if (items.length) {
    params.items = items;
  }

  let areaId = [];
  if (params?.areaId) {
    try {
      areaId = JSON.parse(params?.areaId);
    } catch (e) {
      areaId = [];
    }

  }
  delete params.areaId;
  if (areaId.length) {
    params.areaId = areaId;
  }


  let stateId = [];
  if (params?.stateId) {
    try {
      stateId = JSON.parse(params?.stateId);
    } catch (e) {
      stateId = [];
    }
  }
  delete params.stateId;
  if (stateId.length) {
    params.stateId = stateId;
  }

  let itemRange = [];
  if (params?.itemRange) {
    try {
      itemRange = JSON.parse(params?.itemRange);
    } catch (e) {
      itemRange = [];
    }
  }

  delete params.itemRange;
  if (itemRange.length) {
    params.itemRange = itemRange;
  }

  delete params[''];

  const dJobs = await searchApi.searchJob(params);
  const jobResources = await getAllItemJobResource({});
  const fJobs = (dJobs.data || []).map(e => {
    let attributes = e?.agent.attributes || {};
    for (const k in attributes) {
      if (!attributes[k]) {
        delete attributes[k];
      }
    }
    e.agent.attributes = attributes;

    if (e?.attribute) {
      let attribute = e?.attribute || {};
      for (const s in attribute) {
        if (!attribute[s]) {
          delete attribute[s];
        }
      }
      e.attribute = attribute;
    }


    const dt = pick(e, ['workHours', 'workDetail', 'location', 'agentId', 'title', 'id', 'nickName', 'address', 'imageJobs', 'tagNameJobs', 'area', 'state', 'attribute', 'countMembersApplicanJob']);
    dt.agent = pick(e.agent, ['id', 'nickName', 'address', 'urlCompany', 'urlLp', 'googleMap', 'attributes', 'address', 'imageJobs']);

    return dt;
  });

  const agentResource = await getAllResource();

  const agentResourceShows = agentResource?.data
      ?.filter((item) => item.value === PROFILE.ROOT)
      .map(e => {
        return pick(e, ['profileOrder', 'label', 'profile', 'item', 'value']);
      })
      .sort((a, b) => a.profileOrder - b.profileOrder);

  return {
    dJobs: fJobs,
    message: dJobs?.message || '',
    jobResources: (jobResources?.data || []).map(e => {
      delete e?.id;

      return e;
    }),
    agentResource: {
      // data: [],
      data: (agentResource?.data || []).map(e => {

        return pick(e, ['profile', 'label', 'item', 'profileOrder', 'value']);
      }),
      agentResourceShows
    },
  };
};

export default SearchJobTrialResult;
